import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M26.0488 12.335C26.4951 11.8886 27.2187 11.8886 27.665 12.335C28.1114 12.7813 28.1114 13.5049 27.665 13.9512L21.6162 20L27.665 26.0488C28.1114 26.4951 28.1114 27.2187 27.665 27.665C27.2187 28.1114 26.4951 28.1114 26.0488 27.665L20 21.6162L13.9512 27.665C13.5049 28.1114 12.7813 28.1114 12.335 27.665C11.8886 27.2187 11.8886 26.4951 12.335 26.0488L18.3838 20L12.335 13.9512C11.8886 13.5049 11.8886 12.7813 12.335 12.335C12.7813 11.8886 13.5049 11.8886 13.9512 12.335L20 18.3838L26.0488 12.335Z",
		fill: "#1E1E1E"
	})]
});
export default SvgClose;
